import { defineStore } from 'pinia'

import type { DisciplinePaymentLinksStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'
import { createDisciplinePaymentLinksState } from './state'

export const useDisciplinePaymentLinksStore = defineStore('discipline-payment-links', {
  state: (): DisciplinePaymentLinksStore => createDisciplinePaymentLinksState(),
  actions,
  getters,
})
